(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/*!
 * jQuery UI Touch Punch 0.2.2
 *
 * Copyright 2011, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */
(function ($) {

  // Detect touch support
  $.support.touch = 'ontouchend' in document;

  // Ignore browsers without touch support
  if (!$.support.touch) {
    return;
  }

  var mouseProto = $.ui.mouse.prototype,
      _mouseInit = mouseProto._mouseInit,
      touchHandled;

  /**
   * Simulate a mouse event based on a corresponding touch event
   * @param {Object} event A touch event
   * @param {String} simulatedType The corresponding mouse event
   */
  function simulateMouseEvent (event, simulatedType) {

    // Ignore multi-touch events
    if (event.originalEvent.touches.length > 1) {
      return;
    }

    event.preventDefault();

    var touch = event.originalEvent.changedTouches[0],
        simulatedEvent = document.createEvent('MouseEvents');
    
    // Initialize the simulated mouse event using the touch event's coordinates
    simulatedEvent.initMouseEvent(
      simulatedType,    // type
      true,             // bubbles                    
      true,             // cancelable                 
      window,           // view                       
      1,                // detail                     
      touch.screenX,    // screenX                    
      touch.screenY,    // screenY                    
      touch.clientX,    // clientX                    
      touch.clientY,    // clientY                    
      false,            // ctrlKey                    
      false,            // altKey                     
      false,            // shiftKey                   
      false,            // metaKey                    
      0,                // button                     
      null              // relatedTarget              
    );

    // Dispatch the simulated event to the target element
    event.target.dispatchEvent(simulatedEvent);
  }

  /**
   * Handle the jQuery UI widget's touchstart events
   * @param {Object} event The widget element's touchstart event
   */
  mouseProto._touchStart = function (event) {

    var self = this;

    // Ignore the event if another widget is already being handled
    if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
      return;
    }

    // Set the flag to prevent other widgets from inheriting the touch event
    touchHandled = true;

    // Track movement to determine if interaction was a click
    self._touchMoved = false;

    // Simulate the mouseover event
    simulateMouseEvent(event, 'mouseover');

    // Simulate the mousemove event
    simulateMouseEvent(event, 'mousemove');

    // Simulate the mousedown event
    simulateMouseEvent(event, 'mousedown');
  };

  /**
   * Handle the jQuery UI widget's touchmove events
   * @param {Object} event The document's touchmove event
   */
  mouseProto._touchMove = function (event) {

    // Ignore event if not handled
    if (!touchHandled) {
      return;
    }

    // Interaction was not a click
    this._touchMoved = true;

    // Simulate the mousemove event
    simulateMouseEvent(event, 'mousemove');
  };

  /**
   * Handle the jQuery UI widget's touchend events
   * @param {Object} event The document's touchend event
   */
  mouseProto._touchEnd = function (event) {

    // Ignore event if not handled
    if (!touchHandled) {
      return;
    }

    // Simulate the mouseup event
    simulateMouseEvent(event, 'mouseup');

    // Simulate the mouseout event
    simulateMouseEvent(event, 'mouseout');

    // If the touch interaction did not move, it should trigger a click
    if (!this._touchMoved) {

      // Simulate the click event
      simulateMouseEvent(event, 'click');
    }

    // Unset the flag to allow other widgets to inherit the touch event
    touchHandled = false;
  };

  /**
   * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
   * This method extends the widget with bound touch event handlers that
   * translate touch events to mouse events and pass them to the widget's
   * original mouse event handling methods.
   */
  mouseProto._mouseInit = function () {
    
    var self = this;

    // Delegate the touch handlers to the widget's element
    self.element
      .bind('touchstart', $.proxy(self, '_touchStart'))
      .bind('touchmove', $.proxy(self, '_touchMove'))
      .bind('touchend', $.proxy(self, '_touchEnd'));

    // Call the original $.ui.mouse init method
    _mouseInit.call(self);
  };

})(jQuery);
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/vendor/jquery.ui.touch-punch.js","/admin/source/js/app/lib/vendor")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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